import Vue from 'vue'
import VueI18n from 'vue-i18n';
import store from '../store/store'
import {config} from '../shared/app.config';

store.commit('recoverLanguages');

let request = {};
const path = location.pathname;

path.indexOf(1);

path.toLowerCase();

const first = path.split('/')[1];


const languages = config.locales;
let lang = config.defaultLocale;

if (first === 'admin') {
  store.commit('recoverCurrentLanguage');

  lang = store.getters.getCurrentLanguage;

  store.commit('setCurrentLanguage', lang);
} else {
  store.commit('recoverCurrentLanguagePublic');

  lang = store.getters.getCurrentLanguagePublic;
  const second = path.split('/')[2];
  if (languages.includes(second)) {
    lang = second;
  }
  store.commit('setCurrentLanguagePublic', lang);
}

request = require(`../translations/${  lang  }.js`);

Vue.use(VueI18n);

export default new VueI18n({
  locale: lang,
  messages: request.default
});
